// DS: MO 7.2 PCP Right Rail Promotion
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import DownloadIcon16 from '@wix/da-ds/pkg/Icons/16x16/Download';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationShopCard from '../../../../ShopCard/DeviationShopCard';

interface Props {
  deviations?: PapiDeviation[];
  width: number;
  overrideHref?: string;
}

const PremiumDownloadPromo: React.FC<Props> = ({
  deviations = [],
  width,
  overrideHref,
}) => {
  const { t } = useTranslation();
  const deviation = deviations.find(Boolean);
  if (!deviation) {
    return null;
  }

  return (
    <DeviationShopCard
      deviation={deviation}
      width={width}
      withStats
      withPremiumDownloadCount
      overrideHref={overrideHref}
      footerSlot={
        <BuyButton
          icon={DownloadIcon16}
          size="medium"
          rounded={true}
          fillContainerWidth={true}
          isFakeButton
        >
          {t('sidebar.premiumDownloadPromo.cta')}
        </BuyButton>
      }
    />
  );
};

PremiumDownloadPromo.displayName = 'PremiumDownloadPromo';

export default PremiumDownloadPromo;
